module.exports = __webpack_public_path__ + "static/media/Contact_Background.6ba5ff63.svg";